import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { LinkProps } from "@insite/mobius/Link";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import StoreAnchorLink, { StoreAnchorProps } from "@store/Components/Store/StoreAnchorLink";
import { TYPOGRAPHY } from "@store/theme/design";
import { mediaOptions } from "@store/utilities/breakpointMediaQueries";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import React from "react";
import { css } from "styled-components";

export interface StoreAnchorMenuProps {
    links: Array<StoreAnchorProps>;
}

export interface StoreAnchorMenuStyles {
    anchorsMenu: InjectableCss;
    anchorsMenuLink: LinkProps;
}

const styles = {
    anchorsMenu: {
        css: css`
            display: flex;
            width: 100%;
            background-color: ${getColor("common.accent")};
            justify-content: center;
            padding: 0 1.25em;
            font-size: ${TYPOGRAPHY.size.smaller};
            font-weight: ${TYPOGRAPHY.weight.black};

            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, null, null, "0 2.5em"], properties: ["padding"] }],
                    mediaOptions.min,
                )}
        `,
    },
    anchorsMenuLink: {
        css: css`
            padding: 1.25em;
            color: ${getColor("text.main")};
            text-align: center;

            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, null, null, "1.25em 2.5em"], properties: ["padding"] }],
                    mediaOptions.min,
                )}

            &:hover {
                text-decoration: underline;
            }
        `,
    },
};

const StoreAnchorMenu: React.FC<StoreAnchorMenuProps> = ({ links }) => {
    return (
        <StyledWrapper {...anchorStyles.anchorsMenu}>
            {links.map((link: StoreAnchorProps) => {
                return <StoreAnchorLink key={link.anchor} {...link} {...anchorStyles.anchorsMenuLink} />;
            })}
        </StyledWrapper>
    );
};

export const anchorStyles = styles;
export default StoreAnchorMenu;
